/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateOrganizationResult } from '../model/createOrganizationResult';
import { PetSize } from '../model/petSize';
import { PromotionDtoGetOrganizationResult } from '../model/promotionDtoGetOrganizationResult';
import { PromotionDtoGetOrganizationsResult } from '../model/promotionDtoGetOrganizationsResult';
import { UpdatePromotionNotesCommand } from '../model/updatePromotionNotesCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PromotionsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param search 
     * @param country 
     * @param city 
     * @param latitude 
     * @param longitude 
     * @param radiusKm 
     * @param isOpen 
     * @param managerUid 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsGet(search?: string, country?: string, city?: string, latitude?: number, longitude?: number, radiusKm?: number, isOpen?: boolean, managerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<PromotionDtoGetOrganizationsResult>;
    public promotionsGet(search?: string, country?: string, city?: string, latitude?: number, longitude?: number, radiusKm?: number, isOpen?: boolean, managerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PromotionDtoGetOrganizationsResult>>;
    public promotionsGet(search?: string, country?: string, city?: string, latitude?: number, longitude?: number, radiusKm?: number, isOpen?: boolean, managerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PromotionDtoGetOrganizationsResult>>;
    public promotionsGet(search?: string, country?: string, city?: string, latitude?: number, longitude?: number, radiusKm?: number, isOpen?: boolean, managerUid?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('Search', <any>search);
        }
        if (country !== undefined && country !== null) {
            queryParameters = queryParameters.set('Country', <any>country);
        }
        if (city !== undefined && city !== null) {
            queryParameters = queryParameters.set('City', <any>city);
        }
        if (latitude !== undefined && latitude !== null) {
            queryParameters = queryParameters.set('Latitude', <any>latitude);
        }
        if (longitude !== undefined && longitude !== null) {
            queryParameters = queryParameters.set('Longitude', <any>longitude);
        }
        if (radiusKm !== undefined && radiusKm !== null) {
            queryParameters = queryParameters.set('RadiusKm', <any>radiusKm);
        }
        if (isOpen !== undefined && isOpen !== null) {
            queryParameters = queryParameters.set('IsOpen', <any>isOpen);
        }
        if (managerUid !== undefined && managerUid !== null) {
            queryParameters = queryParameters.set('ManagerUid', <any>managerUid);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PromotionDtoGetOrganizationsResult>('get',`${this.basePath}/Promotions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param contactMobileNumber 
     * @param contactAdditionalMobileNumbers 
     * @param contactDutyMobileNumber 
     * @param contactPhoneNumber 
     * @param contactStreet 
     * @param contactCity 
     * @param contactPostalCode 
     * @param contactCountry 
     * @param contactWebsite 
     * @param contactInstagram 
     * @param contactFacebook 
     * @param contactLinkedIn 
     * @param description 
     * @param email 
     * @param logo 
     * @param petSizes 
     * @param promotionLink 
     * @param isPinned 
     * @param managerUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsPostForm(name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'body', reportProgress?: boolean): Observable<CreateOrganizationResult>;
    public promotionsPostForm(name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateOrganizationResult>>;
    public promotionsPostForm(name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateOrganizationResult>>;
    public promotionsPostForm(name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





















        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (name !== undefined) {
            formParams = formParams.append('Name', <any>name) as any || formParams;
        }
        if (contactMobileNumber !== undefined) {
            formParams = formParams.append('Contact.MobileNumber', <any>contactMobileNumber) as any || formParams;
        }
        if (contactAdditionalMobileNumbers) {
            contactAdditionalMobileNumbers.forEach((element) => {
                formParams = formParams.append('Contact.AdditionalMobileNumbers', <any>element) as any || formParams;
            })
        }
        if (contactDutyMobileNumber !== undefined) {
            formParams = formParams.append('Contact.DutyMobileNumber', <any>contactDutyMobileNumber) as any || formParams;
        }
        if (contactPhoneNumber !== undefined) {
            formParams = formParams.append('Contact.PhoneNumber', <any>contactPhoneNumber) as any || formParams;
        }
        if (contactStreet !== undefined) {
            formParams = formParams.append('Contact.Street', <any>contactStreet) as any || formParams;
        }
        if (contactCity !== undefined) {
            formParams = formParams.append('Contact.City', <any>contactCity) as any || formParams;
        }
        if (contactPostalCode !== undefined) {
            formParams = formParams.append('Contact.PostalCode', <any>contactPostalCode) as any || formParams;
        }
        if (contactCountry !== undefined) {
            formParams = formParams.append('Contact.Country', <any>contactCountry) as any || formParams;
        }
        if (contactWebsite !== undefined) {
            formParams = formParams.append('Contact.Website', <any>contactWebsite) as any || formParams;
        }
        if (contactInstagram !== undefined) {
            formParams = formParams.append('Contact.Instagram', <any>contactInstagram) as any || formParams;
        }
        if (contactFacebook !== undefined) {
            formParams = formParams.append('Contact.Facebook', <any>contactFacebook) as any || formParams;
        }
        if (contactLinkedIn !== undefined) {
            formParams = formParams.append('Contact.LinkedIn', <any>contactLinkedIn) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (email !== undefined) {
            formParams = formParams.append('Email', <any>email) as any || formParams;
        }
        if (logo !== undefined) {
            formParams = formParams.append('Logo', <any>logo) as any || formParams;
        }
        if (petSizes) {
            petSizes.forEach((element) => {
                formParams = formParams.append('PetSizes', <any>element) as any || formParams;
            })
        }
        if (promotionLink !== undefined) {
            formParams = formParams.append('PromotionLink', <any>promotionLink) as any || formParams;
        }
        if (isPinned !== undefined) {
            formParams = formParams.append('IsPinned', <any>isPinned) as any || formParams;
        }
        if (managerUid !== undefined) {
            formParams = formParams.append('ManagerUid', <any>managerUid) as any || formParams;
        }

        return this.httpClient.request<CreateOrganizationResult>('post',`${this.basePath}/Promotions`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public promotionsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public promotionsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public promotionsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling promotionsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Promotions/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<PromotionDtoGetOrganizationResult>;
    public promotionsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PromotionDtoGetOrganizationResult>>;
    public promotionsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PromotionDtoGetOrganizationResult>>;
    public promotionsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling promotionsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PromotionDtoGetOrganizationResult>('get',`${this.basePath}/Promotions/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsUidNotesPatch(uid: string, body?: UpdatePromotionNotesCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public promotionsUidNotesPatch(uid: string, body?: UpdatePromotionNotesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public promotionsUidNotesPatch(uid: string, body?: UpdatePromotionNotesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public promotionsUidNotesPatch(uid: string, body?: UpdatePromotionNotesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling promotionsUidNotesPatch.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/Promotions/${encodeURIComponent(String(uid))}/notes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param uid2 
     * @param name 
     * @param contactMobileNumber 
     * @param contactAdditionalMobileNumbers 
     * @param contactDutyMobileNumber 
     * @param contactPhoneNumber 
     * @param contactStreet 
     * @param contactCity 
     * @param contactPostalCode 
     * @param contactCountry 
     * @param contactWebsite 
     * @param contactInstagram 
     * @param contactFacebook 
     * @param contactLinkedIn 
     * @param description 
     * @param email 
     * @param logo 
     * @param logoUid 
     * @param petSizes 
     * @param promotionLink 
     * @param isPinned 
     * @param managerUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public promotionsUidPutForm(uid: string, uid2?: string, name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, logoUid?: string, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public promotionsUidPutForm(uid: string, uid2?: string, name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, logoUid?: string, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public promotionsUidPutForm(uid: string, uid2?: string, name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, logoUid?: string, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public promotionsUidPutForm(uid: string, uid2?: string, name?: string, contactMobileNumber?: string, contactAdditionalMobileNumbers?: Array<string>, contactDutyMobileNumber?: string, contactPhoneNumber?: string, contactStreet?: string, contactCity?: string, contactPostalCode?: string, contactCountry?: string, contactWebsite?: string, contactInstagram?: string, contactFacebook?: string, contactLinkedIn?: string, description?: string, email?: string, logo?: Blob, logoUid?: string, petSizes?: Array<PetSize>, promotionLink?: string, isPinned?: boolean, managerUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling promotionsUidPut.');
        }























        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (uid !== undefined) {
            formParams = formParams.append('Uid', <any>uid) as any || formParams;
        }
        if (name !== undefined) {
            formParams = formParams.append('Name', <any>name) as any || formParams;
        }
        if (contactMobileNumber !== undefined) {
            formParams = formParams.append('Contact.MobileNumber', <any>contactMobileNumber) as any || formParams;
        }
        if (contactAdditionalMobileNumbers) {
            contactAdditionalMobileNumbers.forEach((element) => {
                formParams = formParams.append('Contact.AdditionalMobileNumbers', <any>element) as any || formParams;
            })
        }
        if (contactDutyMobileNumber !== undefined) {
            formParams = formParams.append('Contact.DutyMobileNumber', <any>contactDutyMobileNumber) as any || formParams;
        }
        if (contactPhoneNumber !== undefined) {
            formParams = formParams.append('Contact.PhoneNumber', <any>contactPhoneNumber) as any || formParams;
        }
        if (contactStreet !== undefined) {
            formParams = formParams.append('Contact.Street', <any>contactStreet) as any || formParams;
        }
        if (contactCity !== undefined) {
            formParams = formParams.append('Contact.City', <any>contactCity) as any || formParams;
        }
        if (contactPostalCode !== undefined) {
            formParams = formParams.append('Contact.PostalCode', <any>contactPostalCode) as any || formParams;
        }
        if (contactCountry !== undefined) {
            formParams = formParams.append('Contact.Country', <any>contactCountry) as any || formParams;
        }
        if (contactWebsite !== undefined) {
            formParams = formParams.append('Contact.Website', <any>contactWebsite) as any || formParams;
        }
        if (contactInstagram !== undefined) {
            formParams = formParams.append('Contact.Instagram', <any>contactInstagram) as any || formParams;
        }
        if (contactFacebook !== undefined) {
            formParams = formParams.append('Contact.Facebook', <any>contactFacebook) as any || formParams;
        }
        if (contactLinkedIn !== undefined) {
            formParams = formParams.append('Contact.LinkedIn', <any>contactLinkedIn) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (email !== undefined) {
            formParams = formParams.append('Email', <any>email) as any || formParams;
        }
        if (logo !== undefined) {
            formParams = formParams.append('Logo', <any>logo) as any || formParams;
        }
        if (logoUid !== undefined) {
            formParams = formParams.append('LogoUid', <any>logoUid) as any || formParams;
        }
        if (petSizes) {
            petSizes.forEach((element) => {
                formParams = formParams.append('PetSizes', <any>element) as any || formParams;
            })
        }
        if (promotionLink !== undefined) {
            formParams = formParams.append('PromotionLink', <any>promotionLink) as any || formParams;
        }
        if (isPinned !== undefined) {
            formParams = formParams.append('IsPinned', <any>isPinned) as any || formParams;
        }
        if (managerUid !== undefined) {
            formParams = formParams.append('ManagerUid', <any>managerUid) as any || formParams;
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Promotions/${encodeURIComponent(String(uid))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
